import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import global from '@/global';



export default function (list) {
    //添加菜单
    let temp = list.filter(r => r.code.indexOf(":") < 0).map(r => {
        return {
            id: r.id,
            parentId: r.parentId,
            kind: r.kind,
            code: r.code,
            title: r.title,
            icon: r.icon
        }
    })
    let tree = global.listToTree(temp)
    store.commit('setMenu', tree);
    //添加路由
    let userRouters = [];
    list.filter(r => r.kind == '2').forEach(item => {
        let pathType = item.code.indexOf(':') >= 0 ? 'fullPath' : 'path';
        userRouters.push({
            path: '/' + item.code,
            name: item.code,
            meta: {
                title: item.title,
                key: pathType
            },
            component: () => import('@/' + item.component)
        })

    });
    router.addRoute({
        path: '/',
        component: () => import('@/views/Layout/Layout.vue'),
        children: userRouters
    });

    if (router.currentRoute.name != 'Home') {
        Vue.nextTick(() => {
            router.replace({
                name: "Home",
            }).catch(ex => {
                console.log(ex)
            })
        })
    }
}